// 반복 행 안 위젯의 역전파(정본 저장) 가용성 — admin 진입점(판정 정본은 shared).
//
// 조건 목록·판정은 `@safetyhub/shared` `report-composer-row-scope-writeback.ts`(`judgeRowScopeWriteBack`·
// `synthesizeComboboxPrefill`)가 **단일 정본**이고 서버 행 스코프 수집기(`apps/server/src/report-composer/
// report-composer.writeback.ts` `collectRowScopeWriteBackWidgets`)도 같은 함수를 부른다. 2026-09-14
// 은닉 감사 3차(소스를 둘로 늘리면 서버는 저장하지 않는데 admin은 「저장된다」고 안내)의 처방이다 —
// ⚠️ 조건 6종을 여기에 손미러하지 말 것. 여기는 admin 호출부 시그니처(`hasWriter` 없음)를 유지하는
// 얇은 진입점이다.
//
// admin에는 서버 writer 레지스트리(`WRITE_BACK_WRITERS`)가 없어 조건 4는 카탈로그 entry의
// `writeBack.upsertKey` 선언을 대리 판정으로 쓴다(keyedPairingCoverage와 같은 대리) — shared 함수의
// `hasWriter` 생략 기본이 정확히 그 판정이므로 그대로 넘긴다.

import type { CatalogEntry, DataSourceDef } from '@safetyhub/shared';
import {
  judgeRowScopeWriteBack as judgeRowScopeWriteBackShared,
  type RowScopeWriteBackJudgement,
  type RowScopeWriteBackWidgetLike,
} from '@safetyhub/shared';

// admin 호출부(EditorPage 4곳·spec)는 종전 이름 `comboboxSyntheticPrefill`로 부른다 — shared 정본
// `synthesizeComboboxPrefill`(서버와 같은 이름)의 별칭 re-export.
export {
  synthesizeComboboxPrefill as comboboxSyntheticPrefill,
  ROW_SCOPE_WRITE_BACK_ELIGIBLE_NOTE,
  ROW_SCOPE_WRITE_BACK_INELIGIBLE,
  type RowScopeWriteBackJudgement,
} from '@safetyhub/shared';

/**
 * 반복 행 안 위젯의 역전파 판정 — shared `judgeRowScopeWriteBack`에 admin 대리 판정(`hasWriter` 생략 =
 * entry `writeBack.upsertKey` 선언)을 얹은 진입점. `over`는 위젯을 감싼 repeat의 over 키
 * (호출부가 findEnclosingRepeatWidget으로 구한다).
 */
export function judgeRowScopeWriteBack(args: {
  widget: RowScopeWriteBackWidgetLike;
  over: string;
  dataSources: DataSourceDef[] | undefined;
  catalog: CatalogEntry[] | undefined;
}): RowScopeWriteBackJudgement {
  return judgeRowScopeWriteBackShared(args);
}
